<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.contects') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <b-button variant="primary" @click="$router.go(-1)">
                        <b-icon icon="arrow-left" class="icon-style"></b-icon>
                    </b-button>
                    <!--                    <b-button variant="primary" @click="$router.push({ name: 'savedMondaycrmLeads' })">-->
                    <!--                        <b-icon icon="bookmark" class="ms-2"></b-icon>-->
                    <!--                    </b-button>-->
                    <template #cell(action)="{ item }">
                        <input type="checkbox" :value="item.owner" v-model="selectedUsers" class="mr-2" />
                    </template>
                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'action', label: self.$t('title.action') },
    { key: 'object_id', label: 'Object ID', sortable: true },
    { key: 'integration_id', label: 'Integration ID', sortable: true },
    { key: 'contact_id', label: 'Contact ID', sortable: true },
    { key: 'contact_uuid', label: 'Contact UUID', sortable: true },
    { key: 'first_name', label: 'First Name', sortable: true },
    { key: 'last_name', label: 'Last Name', sortable: true },
    { key: 'name', label: 'Full Name', sortable: true },
    { key: 'gender_code_text', label: 'Gender', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'phone', label: 'Phone', sortable: true },
    { key: 'mobile', label: 'Mobile', sortable: true },
    { key: 'fax', label: 'Fax', sortable: true },
    { key: 'job_title', label: 'Job Title', sortable: true },
    { key: 'department_code_text', label: 'Department', sortable: true },
    { key: 'account_id', label: 'Account ID', sortable: true },
    { key: 'account_name', label: 'Account Name', sortable: true },
    { key: 'business_address', label: 'Business Address', sortable: true },
    { key: 'business_address_city', label: 'City', sortable: true },
    { key: 'business_address_state', label: 'State', sortable: true },
    { key: 'business_address_country', label: 'Country', sortable: true },
    { key: 'business_address_postal_code', label: 'Postal Code', sortable: true },
    { key: 'created_by', label: 'Created By', sortable: true },
    { key: 'changed_by', label: 'Changed By', sortable: true }
];

export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if (this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
    },
    computed: {
        listUrl() {
            return `admin/sap/contacts/${this.$route.params.id || ''}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
